<template>
  <section class="login">
    <form @submit.prevent="handleSubmit">
      <fieldset class="card small">
        <div class="grid-x grid-padding-x">
          <div class="cell" v-if="autologout">
            <div class="panel center error">Du har automatiskt blitt logget ut</div>
          </div>

          <div class="cell" v-show="error">
            <div class="panel center error">
              Feil brukernavn <em>eller</em> passord
            </div>
          </div>

          <div class="cell" v-if="avantiEnv === 'staging'">
            <div style="color: red; margin-bottom: 1rem;">STAGING</div>
          </div>

          <div class="cell">
            <label for="username">Brukernavn</label>
            <div class="input-container text">
              <input type="text" id="username" name="username" v-model="username">
            </div>
          </div>

          <div class="cell">
            <label for="password">Passord</label>
            <div class="input-container password">
              <input :type="passwordType" id="password" name="password" v-model="password">
              <a href="javascript:;" class="password-toggle" @click="tooglePasswordType()" tabindex="-1">
                <svg :class="[passwordType === 'password' ? 'not-visible' : 'visible']" width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invisible"></use></svg>
                <svg :class="[passwordType === 'password' ? 'visible' : 'not-visible']" width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg>
              </a>
            </div>
          </div>

          <div class="cell auto">
            <!--a href="login-password-forgot.html" class="button primary submit large transparent">Glemt passord?</a-->
          </div>

          <div class="cell shrink">
            <button v-if="!processing" href="javascript:;" class="button primary submit large">Logg inn</button>
            <button v-else type="submit" class="button primary loading">Logger inn<span class="loader-spinner"></span></button>
          </div>
        </div>
      </fieldset>
    </form>

    <div class="login-footer">
      <div class="nav-logo"></div>
      <h1 v-if="avantiEnv === 'production'">Blomqvist Avanti</h1>
      <h1 v-if="avantiEnv === 'local'">Blomqvist Avanti (local)</h1>
      <h1 v-if="avantiEnv === 'staging'" style="color: red">Blomqvist Avanti (staging)</h1>
      <span class="version">Version 0.1.8</span>
    </div>
  </section>
</template>

<script>
import { AUTH_REQUEST } from '../../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'UserLogin',
  data () {
    return {
      username: '',
      password: '',
      error: '',
      passwordType: 'password',
      processing: false,
      autologout: false
    }
  },
  mounted () {
    window.jQuery('#username').focus()

    if (sessionStorage.autologout) {
      sessionStorage.removeItem('autologout')
      this.autologout = true
    }
  },
  methods: {
    tooglePasswordType: function () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    handleSubmit: function () {
      if (this.processing) {
        return
      }
      this.autologout = false
      this.processing = true
      this.error = false

      const { username, password } = this

      this.$store.dispatch(AUTH_REQUEST, { username, password })
        .then((response) => {
          if (response.data.success === false && response.data.method === 'sms') {
            this.$router.push('/verify')
          } else {
            this.$router.push('/dashboard')
          }
        })
        .catch(() => {
          this.error = true
        })
        .then(() => {
          this.processing = false
        })
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guest/UserLogin.vue